import styled from "styled-components"

import { MCard } from "src/ui/MCard/MCard"

export function MinutAIPreview() {
  return (
    <StyledCard boxShadow={false} border>
      <div>Not implemented</div>
    </StyledCard>
  )
}

const StyledCard = styled(MCard)`
  height: 100%;
`
